import type { SVGProps } from "react";
const SvgArrowDown01Sharp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m5 7.5 4.41 4.41c.279.278.417.417.59.417s.312-.139.59-.416L15 7.5"
    />
  </svg>
);
export default SvgArrowDown01Sharp;
